// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.2554 12.8233C14.462 12.4121 14.9628 12.2462 15.3741 12.4528 16.7361 13.137 17.8875 14.2262 18.7207 15.5685 18.8469 15.7718 19.0307 16.0434 19.0878 16.4114 19.1488 16.8054 19.0419 17.1822 18.8825 17.4686 18.7232 17.7551 18.4595 18.0447 18.0925 18.2006 17.7436 18.3489 17.3641 18.3333 17.0834 18.3333 16.6231 18.3333 16.25 17.9602 16.25 17.5 16.25 17.0398 16.6231 16.6667 17.0834 16.6667 17.2627 16.6667 17.357 16.6662 17.4243 16.6616L17.426 16.6585C17.442 16.6298 17.3209 16.4736 17.3047 16.4475 16.6195 15.3437 15.6904 14.4768 14.6259 13.9421 14.2147 13.7355 14.0488 13.2346 14.2554 12.8233ZM12.5871 2.51894C12.7919 2.1068 13.2921 1.93872 13.7042 2.14354 15.2114 2.89253 16.25 4.4492 16.25 6.25001 16.25 8.05081 15.2114 9.60748 13.7042 10.3565 13.2921 10.5613 12.7919 10.3932 12.5871 9.98107 12.3823 9.56892 12.5503 9.06876 12.9625 8.86394 13.9249 8.38567 14.5834 7.39397 14.5834 6.25001 14.5834 5.10604 13.9249 4.11434 12.9625 3.63607 12.5503 3.43125 12.3823 2.93109 12.5871 2.51894Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.33336 6.25001C3.33336 3.7187 5.38539 1.66667 7.91669 1.66667 10.448 1.66667 12.5 3.7187 12.5 6.25001 12.5 8.78131 10.448 10.8333 7.91669 10.8333 5.38539 10.8333 3.33336 8.78131 3.33336 6.25001ZM7.91669 11.6667C10.5802 11.6667 12.9613 13.1701 14.4143 15.3501 14.5423 15.5422 14.6788 15.747 14.7743 15.9416 14.8891 16.1759 14.9716 16.4451 14.9523 16.7665 14.9369 17.0229 14.8519 17.2608 14.7508 17.4496 14.6497 17.6384 14.4988 17.8411 14.294 17.996 14.0196 18.2035 13.7238 18.2763 13.4624 18.3067 13.2322 18.3335 12.9596 18.3334 12.685 18.3333 9.50735 18.3327 6.32727 18.3327 3.14842 18.3333 2.8738 18.3334 2.60118 18.3335 2.37098 18.3067 2.10956 18.2763 1.81382 18.2035 1.53939 17.996 1.33453 17.8411 1.18372 17.6384 1.0826 17.4496.981482 17.2608.896439 17.0229.881049 16.7665.861755 16.4451.944255 16.1759 1.05913 15.9416 1.15457 15.747 1.29107 15.5422 1.41909 15.3501 2.87207 13.1701 5.25316 11.6667 7.91669 11.6667Z"
      clipRule="evenodd"
    />
  </svg>
);
const IconUsersFill = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconUsersFill;
